import { render, staticRenderFns } from "./SaldoProdutoModalManage.vue?vue&type=template&id=da52405a&scoped=true"
import script from "./SaldoProdutoModalManage.vue?vue&type=script&lang=js"
export * from "./SaldoProdutoModalManage.vue?vue&type=script&lang=js"
import style0 from "./SaldoProdutoModalManage.vue?vue&type=style&index=0&id=da52405a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da52405a",
  null
  
)

export default component.exports